import React, { Suspense, useContext } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { SideBar } from '../components/SideBar';
import { BranchesProvider } from '../context/BranchesContext';
import { NewRequestProvider } from '../context/NewRequestContext';
import { SideBarContext } from '../context/SideBarContext';
import { CustomersInner } from './customers/CustomersInner';

const Customers = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { sideBarVissible } = useContext(SideBarContext);

    return (
        <BranchesProvider>
            <NewRequestProvider>
                <div className={`d-flex wrapper ${sideBarVissible && 'sidebar-active'} w-100`}>
                    <SideBar>
                        <Navigation />
                    </SideBar>
                    <div className='d-flex content-wrapper flex-column justify-content-start bg-light align-items-start w-100'>
                        <Header title={t('customers')} />
                        <Suspense fallback={<Spinner animation='border' />}>
                            <CustomersInner />
                        </Suspense>
                    </div>
                </div>
            </NewRequestProvider>
        </BranchesProvider>
    );
};

export default Customers;
